import {
  GET_COURSES,
  GET_COURSES_LIST,
  GET_COURSES_MINIMAL,
  GET_COURSE,
  ADD_COURSE,
  DELETE_COURSE,
  UPDATE_COURSE,
  COURSES_LOADING,
  COURSE_LOADING,
  CLEAR_CURRENT_COURSE,
  SET_COURSES_PAGE
} from '../actions/types';

const initialState = {
  courses: [],           // Lightweight list for table
  coursesMinimal: [],    // Minimal courses for dropdowns/pickers
  currentCourse: null,   // Full course data for view/edit pages
  loading: false,        // For list loading
  courseLoading: false,  // For single course loading
  currentPage: 1,        // Current page number
  totalPages: 0,         // Total number of pages
  totalCourses: 0,       // Total number of courses
  hasNextPage: false,    // Whether there's a next page
  hasPrevPage: false     // Whether there's a previous page
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_COURSES_LIST:
      return {
        ...state,
        courses: action.payload.courses || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalCourses: action.payload.totalCourses || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_COURSES_MINIMAL:
      return {
        ...state,
        coursesMinimal: action.payload,
        loading: false
      };

    case GET_COURSE:
      return {
        ...state,
        currentCourse: action.payload,
        courseLoading: false
      };

    case COURSE_LOADING:
      return { ...state, courseLoading: true };

    case CLEAR_CURRENT_COURSE:
      return { ...state, currentCourse: null, courseLoading: false };

    case ADD_COURSE:
      return {
        ...state,
        // Add lightweight version to list
        courses: [
          {
            _id: action.payload._id,
            title: action.payload.title,
            description: action.payload.description,
            tags: action.payload.tags,
            thumbnail: action.payload.thumbnail,
            lessonsCount: action.payload.lessons?.length || 0,
            submissionFormsCount: action.payload.submissionForms?.length || 0,
            createdAt: action.payload.createdAt,
            updatedAt: action.payload.updatedAt
          },
          ...state.courses
        ],
        currentCourse: action.payload
      };

    case UPDATE_COURSE:
      return {
        ...state,
        // Update in list
        courses: state.courses.map(course =>
          course._id === action.payload._id
            ? {
                _id: action.payload._id,
                title: action.payload.title,
                description: action.payload.description,
                tags: action.payload.tags,
                thumbnail: action.payload.thumbnail,
                lessonsCount: action.payload.lessons?.length || 0,
                submissionFormsCount: action.payload.submissionForms?.length || 0,
                createdAt: action.payload.createdAt,
                updatedAt: action.payload.updatedAt
              }
            : course
        ),
        currentCourse: action.payload
      };

    case DELETE_COURSE:
      return {
        ...state,
        courses: state.courses.filter(course => course._id !== action.payload),
        currentCourse: null
      };

    case COURSES_LOADING:
      return { ...state, loading: true };

    case GET_COURSES: // Keep for backward compatibility
      return { ...state, courses: action.payload, loading: false };

    case SET_COURSES_PAGE:
      return { ...state, currentPage: action.payload };

    default:
      return state;
  }
}
